/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */
import {
  Box,
  Button, FormControl, FormControlLabel, makeStyles, Radio, RadioGroup, withStyles,
} from '@material-ui/core';
import PropTypes from 'prop-types';

import { setAnalytics } from '../../utils';

const useStyles = makeStyles((theme) => ({
  containerRadioButton: {
    padding: theme.spacing(2, 9),
  },
  contentRadioButton: {
    margin: theme.spacing(0, 0, 3, 0),
  },
  containerButton: {
    fontFamily: 'Raleway',
    borderRadius: 10,
    background: theme.palette.background.secondary,
    color: theme.palette.background.default,
    '&:hover': {
      background: theme.palette.common.pinkLigth,
    },
    '&:disabled': {
      background: theme.palette.common.gray,
    },
  },
  marginUnit: {
    margin: theme.spacing(2, 0),
  },
}));
const StyleRadio = withStyles({
  root: {
    color: '#21456E',
    '&$checked': {
      color: '#FCD050',
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);

const StylesFormControlLabel = withStyles({
  label: {
    '&.MuiFormControlLabel-label': {
      fontFamily: 'Raleway',
      color: '#FFFFFF',
      fontSize: 16,
    },
  },
})((props) => <FormControlLabel {...props} />);

function RadioButtonsContainer({
  value, changeValue, options, actions,
  correctAnswer, indexQuestion, totalQuestions,
  idQuestion, amountScore, storeAnswers, finalAction, isLoading, backAction,
}) {
  const classes = useStyles();

  const handleActions = () => {
    if (value === correctAnswer) {
      amountScore();
    }
    storeAnswers({
      id: idQuestion,
      answer: value,
    });
    actions();
  };
  const handleFinalAction = () => {
    if (value === correctAnswer) {
      setAnalytics('Evaluation', 'Btn_FinalizarEvaluacion');
      amountScore();
    }
    finalAction();
  };

  return (
    <Box className={classes.containerRadioButton}>
      <FormControl component="fieldset">
        <RadioGroup aria-label="gender" name={idQuestion} value={value} onChange={changeValue} className={classes.contentRadioButton}>
          {options.map(
            (e) => (
              <div className={classes.marginUnit}>
                <StylesFormControlLabel
                  value={e}
                  key={e}
                  control={<StyleRadio />}
                  label={e}
                />
              </div>
            ),
          )}
        </RadioGroup>
        { totalQuestions === indexQuestion + 1
          ? !isLoading ? <Box><Button color="secondary" variant="contained" className={classes.containerButton} disabled={value === ''} onClick={handleFinalAction}>Finalizar Evaluación </Button></Box>
            : <Box><Button color="secondary" variant="contained" className={classes.containerButton}>Cargando... </Button></Box>
          : (
            <Box>
              {/* {indexQuestion === 0 ? null :
                <Button color="secondary" variant="contained"
                className={classes.containerButton} onClick={backAction}>Atrás</Button> } */}
              <Button color="secondary" variant="contained" className={classes.containerButton} disabled={!value} onClick={handleActions}>Enviar</Button>
            </Box>
          )}
      </FormControl>
    </Box>
  );
}

export default RadioButtonsContainer;

RadioButtonsContainer.propTypes = {
  value: PropTypes.string.isRequired,
  changeValue: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  actions: PropTypes.func.isRequired,
  correctAnswer: PropTypes.string.isRequired,
  indexQuestion: PropTypes.number.isRequired,
  totalQuestions: PropTypes.number.isRequired,
  idQuestion: PropTypes.string.isRequired,
  amountScore: PropTypes.func.isRequired,
  storeAnswers: PropTypes.func.isRequired,
  finalAction: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  // backAction: PropTypes.func.isRequired,
};
